import React from 'react';
import { Link } from 'react-router-dom';
import AlertBar from '../../components/alertBar';
import Header from '../../components/header';
import BigImageSlider from '../../components/bigImageSlider';
import Footer from '../../components/footer';
import languageService from '../../services/language';
import './index.css';

//5: 'Proiectul SPICE'
//5: 'SPICE Project'

export default (props, routerProps) => ({
  render() {
    const buttons = {
      'Ro': {
        1: 'Transparență decizională',
        2: 'Cariere / Locuri de muncă',
        3: 'Declarații de avere și interese',
        4: 'Informații despre aeroport',
        5: 'Solicitare informații. Legislație.'
      },
      'En': {
        1: 'Decision making',
        2: 'Careers',
        3: 'Statements of wealth and interests',
        4: 'Airport info',
        5: 'Ask for information. Legislation'
      }
    }[languageService.language];

    return (
      <div className="viewsInfoPublic">
        <Header {...props} />
        <AlertBar showLink={true} />
        <BigImageSlider {...props} />

        <div className="padded-top-content">
          <div className="col-md-8 offset-md-2 m-t-big">
            <Link className="btn btn-info" to="/infopublic/transparenta-decizionala">
              <span>{buttons[1]}</span>
            </Link>

            <Link className="btn btn-info" to="/infopublic/cariere">
              <span>{buttons[2]}</span>
            </Link>

            <Link className="btn btn-info" to="/infopublic/declaratii-de-avere-si-interese">
              <span>{buttons[3]}</span>
            </Link>

            <Link className="btn btn-info" to="/infopublic/info-aeroport">
              <span>{buttons[4]}</span>
            </Link>

            <Link className="btn btn-info" to="/infopublic/legislatie">
              <span>{buttons[5]}</span>
            </Link>
          </div>

          <Footer {...props} />
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/infopublic/index.js